import { configureStore } from '@reduxjs/toolkit';
import dataSummaryReducer from '../features/adminSummary/summarySlice';
import evaluatorListReducer from '../features/evaluator/evaluatorSlice';
import branchListReducer from '../features/branch/branchSlice';
import reportReducer from '../features/report/reportSlice';

export const store = configureStore({
  reducer: {
    dataSummary: dataSummaryReducer,
    evaluators: evaluatorListReducer,
    branches: branchListReducer,
    reports: reportReducer,
  },
});
